/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 of 1.0 for dsDNA (dilution 1) = 50 µg/mL.`)
};

const es_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 1.0 para ADNds (dilución 1) = 50 µg/mL.`)
};

const de_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 von 1,0 für dsDNA (Verdünnung 1) = 50 µg/mL.`)
};

const nl_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 van 1,0 voor dsDNA (verdunning 1) = 50 µg/mL.`)
};

const fr_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 1,0 pour l'ADNdb (dilution 1) = 50 µg/mL.`)
};

const it_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 di 1,0 per dsDNA (diluizione 1) = 50 µg/mL.`)
};

const pt_br2_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 1,0 para dsDNA (diluição 1) = 50 µg/mL.`)
};

const pt_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 1,0 para dsADN (diluição 1) = 50 µg/mL.`)
};

const ja_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNAのA260が1.0（希釈倍率1）= 50 µg/mL。`)
};

const zh_od_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA 的 A260 为 1.0（稀释倍数 1）= 50 µg/mL。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ex1", locale)
	if (locale === "en") return en_od_ex1(inputs)
	if (locale === "es") return es_od_ex1(inputs)
	if (locale === "de") return de_od_ex1(inputs)
	if (locale === "nl") return nl_od_ex1(inputs)
	if (locale === "fr") return fr_od_ex1(inputs)
	if (locale === "it") return it_od_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_od_ex1(inputs)
	if (locale === "pt") return pt_od_ex1(inputs)
	if (locale === "ja") return ja_od_ex1(inputs)
	return zh_od_ex1(inputs)
};